module.exports = __webpack_public_path__ + "static/scale-model-of-big-blue-pedaler-in-lexington-kentucky-3f215b00b47e437bc799cbaa2668cc30.png";